import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import fetchFeedingGuidelinesPersonalizedNutrientProfileAction from './../../store/actions/fetch/fetchFeedingGuidelinesPersonalizedNutrientProfileAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesPersonalizedNutrientProfileAction';
import PersonalizedNutrientProfile from './../../components/FeedingGuidelines/PersonalizedNutrientProfile/PersonalizedNutrientProfile';

import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';

class FeedingGuidelinesPersonalizedNutrientProfile extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData(this.props.output.products, this.props.amounts);
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-personalized-nutrient-profile'); 
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-personalized-nutrient-profile'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const {data, pending, ready, error} = this.props;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}>

        <PersonalizedNutrientProfile data={data}/>

      </OnImagesLoaded>
    )
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesPersonalizedNutrientProfileReducer.data,
    pending: state.feedingGuidelinesPersonalizedNutrientProfileReducer.pending,
    ready: state.feedingGuidelinesPersonalizedNutrientProfileReducer.ready,
    error: state.feedingGuidelinesPersonalizedNutrientProfileReducer.error,
    screenshots: state.pdfOutputReducer.images,
    amounts: state.dailyWetReducer.amounts,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesPersonalizedNutrientProfileAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-personalized-nutrient-profile',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesPersonalizedNutrientProfile);
